{
  "fr": {
    "constants": {
      "address": {
        "city": "Ville",
        "country": "Pays",
        "number": "Numéro",
        "street": "Rue",
        "zip": "Code postal"
      },
      "crud": {
        "created_at": "Aangemaakt op",
        "deleted_at": "Verwijderd op",
        "updated_at": "Gewijzigd op"
      },
      "currencies": {
        "all": "Toutes les devises",
        "popular": "Populaires"
      },
      "days": ["di", "lu", "ma", "mer", "je", "ve", "sa"],
      "languages": {
        "de": "Allemand",
        "en": "Anglais",
        "fallback_info": "Il semble que ce message ne soit pas disponible dans votre langue. Nous utilisons à la place la traduction {fallback_locale} existante.",
        "fr": "Français",
        "nl": "Néerlandais",
        "pl": "Polonais",
        "pt": "Portugais"
      },
      "languages_short": {
        "de": "DE",
        "en": "EN",
        "fr": "FR",
        "nl": "NL",
        "pl": "PL",
        "pt": "PT"
      },
      "measurements": {
        "imperial": "Impérial",
        "metric": "Métrique",
        "surface": {
          "imperial": "Sq. ft",
          "metric": "m²",
          "null": ""
        }
      },
      "months": [
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre"
      ],
      "profile_statuses": {
        "active": "Actif",
        "added": "Sans invitation",
        "blocked": "Déactivé",
        "discarded": "Supprimé",
        "invited": "Invité",
        "invited_at": "Invité"
      },
      "profile_statuses_descriptive": {
        "active": "Dernière fois actif sur la plateforme: {session_ended_at}",
        "added": "Pas encore invité",
        "blocked": "Déactivé",
        "discarded": "Supprimé",
        "invited": "Invité mais pas encore inscrit",
        "invited_at": "Invité {invited_at}. Pas encore inscrit"
      },
      "profile_titles": {
        "dr": "Docteur",
        "mr": "Monsieur",
        "mrs": "Madame",
        "professor": "Professeur",
        "sirmadam": "-"
      },
      "time_units": {
        "days": "Jours",
        "months": "Mois",
        "weeks": "Semaines"
      },
      "time_units_count": {
        "days": "pas de jour | jour | jours",
        "months": "pas de mois | mois | mois",
        "weeks": "pas de semaine | semaine | semaines"
      },
      "timezone_regions": {
        "Africa": "Afrique",
        "America": "Amérique",
        "Asia": "Asie",
        "Atlantic": "Atlantique",
        "Australia": "Australie",
        "Europe": "Europe",
        "Pacific": "Pacifique"
      },
      "timezones": {
        "Africa/Abidjan": "Afrique/Abidjan",
        "Africa/Cairo": "Afrique/Le Caire",
        "Africa/Casablanca": "Afrique/Casablanca",
        "Africa/Johannesburg": "Afrique/Johannesburg",
        "Africa/Lagos": "Afrique/Lagos",
        "Africa/Nairobi": "Afrique/Nairobi",
        "America/Anchorage": "Amérique/Anchorage",
        "America/Bogota": "Amérique/Bogota",
        "America/Buenos_Aires": "Amérique/Buenos Aires",
        "America/Chicago": "Amérique/Chicago",
        "America/Denver": "Amérique/Denver",
        "America/Halifax": "Amérique/Halifax",
        "America/Lima": "Amérique/Lima",
        "America/Los_Angeles": "Amérique/Los Angeles",
        "America/Mexico_City": "Amérique/Mexico",
        "America/New_York": "Amérique/New York",
        "America/Phoenix": "Amérique/Phoenix",
        "America/Santiago": "Amérique/Santiago",
        "America/Sao_Paulo": "Amérique/São Paulo",
        "America/St_Johns": "Amérique/St. John's",
        "America/Toronto": "Amérique/Toronto",
        "America/Vancouver": "Amérique/Vancouver",
        "Asia/Bangkok": "Asie/Bangkok",
        "Asia/Colombo": "Asie/Colombo",
        "Asia/Dhaka": "Asie/Dacca",
        "Asia/Dubai": "Asie/Dubaï",
        "Asia/Ho_Chi_Minh": "Asie/Hô Chi Minh",
        "Asia/Hong_Kong": "Asie/Hong Kong",
        "Asia/Jakarta": "Asie/Jakarta",
        "Asia/Karachi": "Asie/Karachi",
        "Asia/Kolkata": "Asie/Calcutta",
        "Asia/Kuala_Lumpur": "Asie/Kuala Lumpur",
        "Asia/Makassar": "Asie/Makassar",
        "Asia/Manila": "Asie/Manille",
        "Asia/Riyadh": "Asie/Riyad",
        "Asia/Seoul": "Asie/Séoul",
        "Asia/Shanghai": "Asie/Shanghai",
        "Asia/Singapore": "Asie/Singapour",
        "Asia/Taipei": "Asie/Taipei",
        "Asia/Tehran": "Asie/Téhéran",
        "Asia/Tokyo": "Asie/Tokyo",
        "Atlantic/Reykjavik": "Atlantique/Reykjavik",
        "Australia/Adelaide": "Australie/Adélaïde",
        "Australia/Brisbane": "Australie/Brisbane",
        "Australia/Darwin": "Australie/Darwin",
        "Australia/Hobart": "Australie/Hobart",
        "Australia/Melbourne": "Australie/Melbourne",
        "Australia/Perth": "Australie/Perth",
        "Australia/Sydney": "Australie/Sydney",
        "Europe/Amsterdam": "Europe/Amsterdam",
        "Europe/Athens": "Europe/Athènes",
        "Europe/Belgrade": "Europe/Belgrade",
        "Europe/Berlin": "Europe/Berlin",
        "Europe/Brussels": "Europe/Bruxelles",
        "Europe/Bucharest": "Europe/Bucarest",
        "Europe/Budapest": "Europe/Budapest",
        "Europe/Copenhagen": "Europe/Copenhague",
        "Europe/Dublin": "Europe/Dublin",
        "Europe/Helsinki": "Europe/Helsinki",
        "Europe/Istanbul": "Europe/Istanbul",
        "Europe/Lisbon": "Europe/Lisbonne",
        "Europe/London": "Europe/Londres",
        "Europe/Madrid": "Europe/Madrid",
        "Europe/Moscow": "Europe/Moscou",
        "Europe/Oslo": "Europe/Oslo",
        "Europe/Paris": "Europe/Paris",
        "Europe/Prague": "Europe/Prague",
        "Europe/Rome": "Europe/Rome",
        "Europe/Stockholm": "Europe/Stockholm",
        "Europe/Vienna": "Europe/Vienne",
        "Europe/Warsaw": "Europe/Varsovie",
        "Europe/Zurich": "Europe/Zurich",
        "Pacific/Auckland": "Pacifique/Auckland",
        "Pacific/Fiji": "Pacifique/Fidji",
        "Pacific/Honolulu": "Pacifique/Honolulu"
      },
      "wind_orientations": {
        "east": "Est",
        "north": "Nord",
        "northeast": "Nord-Est",
        "northwest": "Nord-Ouest",
        "select": "Sélectionner Orientation",
        "south": "Sud",
        "southeast": "Sud-Est",
        "southwest": "Sud-Ouest",
        "west": "Ouest"
      }
    }
  }
}
